var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgHamburgerMenu = function SvgHamburgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.105 1.746h24M1.105 9.746h24M1.105 17.746h24",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export default __webpack_public_path__ + "static/media/HamburgerMenu.aaf69cb3.svg";
export { SvgHamburgerMenu as ReactComponent };